import './styles/ViewMeetings.scss';
import { AppContext, ExAppContext } from '../../Context';
import { ViewMeetings_PageMap, MemberUser_CommitteeTypeMap, EventCategory_CategoryTypeMap, MeetingInvitation_InvitationStatusMap } from '../../assets/keyMap';
import { useContext, useState, useRef, useEffect, Fragment } from 'react';
import { Browser } from '@capacitor/browser';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { IonDate, IonDateFormat, IonDateString } from '../../components/IonDate';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener';
import { useLocation } from 'react-router';

//classes
import MemberUser from '../../classes/memberUser';
import EventCategory from '../../exClasses/eventCategory';
import SelectionList from '../../classes/selectionList';
import MeetingInvitation from '../../exClasses/meetingInvitation';
import Event from '../../exClasses/event';
import CommitteeType from '../../exClasses/committeeType';
import EventItem from '../../exClasses/eventItem';
import { isPlatform } from '@ionic/react';

//components
import Checker from '../../components/Checker';
import DateTimePicker from '../../components/DateTimePicker';
import SelectionChecker from '../../components/SelectionChecker';
import SelectionBox from '../../components/SelectionBox';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//muis
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RecyclingIcon from '@mui/icons-material/Recycling';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import ListIcon from '@mui/icons-material/List';
import InfoIcon from '@mui/icons-material/Info';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ReplayIcon from '@mui/icons-material/Replay';

class SortMap {
    public titleSort: boolean = true; //true ascending
    public dateSort: boolean = false; //false descending

    constructor(titleSort: boolean, dateSort: boolean) {
        this.titleSort = titleSort;
        this.dateSort = dateSort;
    }
}
class AttachmentMap {
    public fileName: string = '';
    public source: string = ''; //can be base64String or urlSource
    public datetime_expired: Date | null = null;
}
class CommitteeTypesListCheckings {
    public committeeType: CommitteeType = {} as CommitteeType;
    public list: MemberUser[] = [] as MemberUser[];
    public checkings: boolean[] = [] as boolean[];
}
const nonstate = {
    alphabetNumericOrderMap: {
        'a': 1,
        'b': 2,
        'c': 3,
        'd': 4,
        'e': 5,
        'f': 6,
        'g': 7,
        'h': 8,
        'i': 9,
        'j': 10,
        'k': 11,
        'l': 12,
        'm': 13,
        'n': 14,
        'o': 15,
        'p': 16,
        'q': 17,
        'r': 18,
        's': 19,
        't': 20,
        'u': 21,
        'v': 22,
        'w': 23,
        'x': 24,
        'y': 25,
        'z': 26,
        '0': 100,
        '1': 101,
        '2': 102,
        '3': 103,
        '4': 104,
        '5': 105,
        '6': 106,
        '7': 107,
        '8': 108,
        '9': 109,
    },
    max_attachment_size: 5, //5Mb
    checkAttachmentCountInterval: 1000,
    autoFetchMeetingInvitationsInterval: 10000
}

interface Props {

}

const ViewMeetings: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState<number>(ViewMeetings_PageMap.UPCOMING);
    const [filter_searchString, SetFilter_SearchString] = useState<string>('');
    const [sort, SetSort] = useState<SortMap>({ titleSort: false, dateSort: false } as SortMap);
    const [shouldShowInvitationsMenu, SetShouldShowInvitationsMenu] = useState<boolean>(false);
    const [shouldShowHostedMeetingsMenu, SetShouldShowHostedMeetingsMenu] = useState<boolean>(false);
    const [shouldShowCreateEditMeetingMenu, SetShouldShowCreateEditMeetingMenu] = useState<boolean>(false);
    const [shouldShowUploadAttachmentMenu, SetShouldShowUploadAttachmentMenu] = useState<boolean>(false);
    // const [committeeList, SetCommitteeList] = useState<MemberUser[]>([] as MemberUser[]);
    // const [committeeCheckings, SetCommitteeCheckings] = useState<boolean[]>([]);
    // const [secretariateList, SetSecretariatList] = useState<MemberUser[]>([] as MemberUser[]);
    // const [secretariateCheckings, SetSecretariateCheckings] = useState<boolean[]>([]);
    // const [advisorList, SetAdvisorList] = useState<MemberUser[]>([] as MemberUser[]);
    // const [advisorCheckings, SetAdvisorCheckings] = useState<boolean[]>([]); ----deprecated to generic
    const [committeeTypesListCheckings, SetCommitteeTypesListCheckings] = useState<CommitteeTypesListCheckings[]>([] as CommitteeTypesListCheckings[]);
    const [meetingCategoriesList, SetMeetingCategoriesList] = useState<SelectionList[]>([] as SelectionList[]);
    const [currentSelectedInvitation, SetCurrentSelectedInvitation] = useState<MeetingInvitation>({} as MeetingInvitation);
    const [currentViewingMeeting, SetCurrentViewingMeeting] = useState<Event>({} as Event);
    const [currentEditingMeeting, SetCurrentEditingMeeting] = useState<Event>({} as Event);
    const [invitedMeetings, SetInvitedMeetings] = useState<Event[]>([] as Event[]);
    const [attemptUploadAttachment, SetAttemptUploadAttachment] = useState<AttachmentMap>({} as AttachmentMap);
    const [attemptUploadFileLabel, SetAttemptUploadFileLabel] = useState('');
    const [attemptUploadFileShouldExpire, SetAttemptUploadFileShouldExpire] = useState(false);
    const [attemptUploadFileDateTimeExpired, SetAttemptUploadFileDateTimeExpired] = useState<Date | null>(null);
    // const [invitedMeetingAttachments, SetInvitedMeetingAttachments] = useState<EventItem[]>([] as EventItem[]); ---deprecated of unused

    const [acceptedOngoingMeetings, SetAcceptedOngoingMeetings] = useState<Event[]>([] as Event[]);
    const [acceptedPastMeetings, SetAcceptedPastMeetings] = useState<Event[]>([] as Event[]);
    const [declinedMeetigs, SetDeclinedMeetings] = useState<Event[]>([] as Event[]);

    // const [hostedMeetings, SetHostedMeetings] = useState<Event[]>([] as Event[]); ---deprecated
    const [uploadAttachmentCount, SetUploadAttachmentCount] = useState<number>(0);
    //form variables
    const [newTitle, SetNewTitle] = useState<string>('');
    const [newAgenda, SetNewAgenda] = useState<string>('');
    const [newAttachments, SetNewAttachments] = useState<AttachmentMap[]>([] as AttachmentMap[]);
    const [newStartDateTime, SetNewStartDateTime] = useState<Date | null>(null);
    const [newEndDateTime, SetNewEndDateTime] = useState<Date | null>(null);
    const [newVenue, SetNewVenue] = useState<string>('');
    const [newMeetingCategoryID, SetNewMeetingCategoryID] = useState<string>('');
    // refs
    const newInvitedIdsRef = useRef<string[]>([]);
    const invitationStatusUpdateRef = useRef<number | null>(null);
    const newAttachmentsRef = useRef<AttachmentMap[]>([] as AttachmentMap[]);
    const attemptUploadFileAttachmentRef = useRef<AttachmentMap>({} as AttachmentMap);
    const uploadAttachmentCountRef = useRef(0);
    const currentEditingMeetingEventIDRef = useRef('');
    const checkAttachmentCountIntervalRef = useRef<any>(null);
    const invitedMeetingsRef = useRef<Event[]>([] as Event[]);
    const invitedMeetingAttachmentRef = useRef<EventItem[]>([] as EventItem[]);
    // refs intervals
    const autoFetchMeetingInvitationsIntervalRef = useRef<any>(null);
    // refs objs
    const menuContentScrollRef = useRef<any>(null);
    //router objs
    const location = useLocation();
    //controller
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('ViewMeetingTest: ' + JSON.stringify(exAppContext.hostedMeetingAttachments));
    // }, [exAppContext.hostedMeetingAttachments]);

    //clear checkAttachmentCountInterval
    useEffect(() => {
        if (autoFetchMeetingInvitationsIntervalRef.current != null)
            clearInterval(autoFetchMeetingInvitationsIntervalRef.current);

        //do for the firt time, then interval will do the rest
        databaseInterfaceController.Queue('fetchMeetingInvitations', [
            ['fetchMeetingInvitations', 'true'],
            ['userID', appContext.user.userID]
        ]);
        databaseInterfaceController.Queue('fetchHostedMeetings', [
            ['fetchHostedMeetings', 'true'],
            ['hostID', appContext.user.userID]
        ]);
        databaseInterfaceController.Queue('fetchHostedMeetingInvitations', [
            ['fetchHostedMeetingInvitations', 'true'],
            ['hostID', appContext.user.userID]
        ]);
        autoFetchMeetingInvitationsIntervalRef.current = setInterval(() => {
            appContext.SetDatabaseShouldShowWaitScreen(false);
            databaseInterfaceController.Queue('fetchMeetingInvitations', [
                ['fetchMeetingInvitations', 'true'],
                ['userID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchHostedMeetings', [
                ['fetchHostedMeetings', 'true'],
                ['hostID', appContext.user.userID]
            ]);
            databaseInterfaceController.Queue('fetchHostedMeetingInvitations', [
                ['fetchHostedMeetingInvitations', 'true'],
                ['hostID', appContext.user.userID]
            ]);
        }, nonstate.autoFetchMeetingInvitationsInterval);

        return (() => {
            if (checkAttachmentCountIntervalRef.current != null)
                clearInterval(checkAttachmentCountIntervalRef.current);
            if (autoFetchMeetingInvitationsIntervalRef.current != null)
                clearInterval(autoFetchMeetingInvitationsIntervalRef.current);

            appContext.SetDatabaseShouldShowWaitScreen(true);
        })
    }, []);

    //watch for location pathname update, navigate to view invitation
    useEffect(() => {
        const pathNameArr = location.pathname.split('/');
        if (pathNameArr.length >= 3) {
            if (pathNameArr[2] == 'Invitations') {
                SetShouldShowInvitationsMenu(true);
            }
        }
    }, [location.pathname]);

    //watch for menu show-hide, resetform
    useEffect(() => {
        if (shouldShowCreateEditMeetingMenu || Object.keys(currentEditingMeeting).length > 0)
            ResetForm();
    }, [shouldShowCreateEditMeetingMenu, currentEditingMeeting]);

    //watch for eventCategories update meetingCategories
    useEffect(() => {
        const _meetingCategoriesList = [] as SelectionList[];
        exAppContext.eventCategories.map((eventCategory: EventCategory) => {
            if (eventCategory.event_category_type == EventCategory_CategoryTypeMap.MEETING)
                _meetingCategoriesList.push({ key: eventCategory.event_categoryID, value: eventCategory.event_category_name } as SelectionList);
        });

        SetMeetingCategoriesList([..._meetingCategoriesList]);
    }, [exAppContext.eventCategories]);

    //watch for committeeMembers update, sort them into committeeList, secretariateList, and advisorList
    useEffect(() => {
        // const _committeeList = [] as MemberUser[];
        // const _secretariateList = [] as MemberUser[];
        // const _advisorList = [] as MemberUser[]; ---deprecated
        const _committeeTypesListCheckings = [] as CommitteeTypesListCheckings[];
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            const committeeMembersOfType = [] as MemberUser[];
            const checkings = [] as boolean[];
            exAppContext.allCommitteeMembers.map((committeeMember: MemberUser) => {
                if (committeeMember.committee_typeID == committeeType.committee_typeID) {
                    committeeMembersOfType.push(committeeMember);
                    checkings.push(false);
                }
            });

            _committeeTypesListCheckings.push({
                committeeType: committeeType,
                list: committeeMembersOfType,
                checkings: checkings
            });
        });
        SetCommitteeTypesListCheckings([..._committeeTypesListCheckings]);

    }, [exAppContext.committeeTypes, exAppContext.allCommitteeMembers]);

    //watch for meetingInvitations update, fetch invitedMeetings
    useEffect(() => {
        //fetch invited meetings && invitedMeetingAttachments
        const invitedMeetingIDsArr = [] as string[];
        if (exAppContext.meetingInvitations.length > 0) {
            exAppContext.meetingInvitations.map((meetingInvitation: MeetingInvitation) => {
                invitedMeetingIDsArr.push(meetingInvitation.eventID);
            });
        }
        databaseInterfaceController.Queue('fetchMeetingsByEventIDs', [
            ['fetchMeetingsByEventIDs', 'true'],
            ['eventIDs', invitedMeetingIDsArr.join(',')]
        ]);
        databaseInterfaceController.Queue('fetchViewableMeetingAttachmentsByEventIDs', [
            ['fetchViewableMeetingAttachmentsByEventIDs', 'true'],
            ['eventIDs', invitedMeetingIDsArr.join(',')]
        ]);
        databaseInterfaceController.Queue('fetchAcceptedUpcomingMeetings', [
            ['fetchAcceptedUpcomingMeetings', 'true'],
            ['userID', appContext.user.userID],
            ['dateNow', IonDateString(new Date())]
        ]);
    }, [exAppContext.meetingInvitations]);

    //watch for meeting invitation & sorting mode update, reassign the accepted/declinedMeetings
    useEffect(() => {
        if (invitedMeetings.length > 0) {
            const dateNow = new Date();
            const _acceptedOngoingMeetings = [] as Event[];
            const _acceptedPastMeetings = [] as Event[];
            const _declinedMeetings = [] as Event[];

            exAppContext.meetingInvitations.map((meetingInvitation: MeetingInvitation) => {
                const meetingEvent = GetInvitedMeetingByID(meetingInvitation.eventID);

                if (meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.ACCEPTED) {
                    //event end_datetime changed to the last item of event_schedules

                    if (meetingEvent.event_end_datetime! && meetingEvent.event_end_datetime >= dateNow)
                        _acceptedOngoingMeetings.push(meetingEvent);
                    else
                        _acceptedPastMeetings.push(meetingEvent);
                } else if (meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.DECLINED) {
                    _declinedMeetings.push(meetingEvent);
                }
            });

            SetAcceptedOngoingMeetings(SortMeetings(FilterMeetings(_acceptedOngoingMeetings), sort));
            SetAcceptedPastMeetings(SortMeetings(FilterMeetings(_acceptedPastMeetings), sort));
            SetDeclinedMeetings(SortMeetings(FilterMeetings(_declinedMeetings), sort));
        }
    }, [invitedMeetings, sort, filter_searchString]);

    //watch for upload attachment count update, upload local selected attachments to server
    useEffect(() => {
        if (uploadAttachmentCount > 0) {
            appContext.SetWaitScreenMessage('Uploading attachment ' + (uploadAttachmentCount).toString() + '/' + newAttachments.length);
            const attachment = newAttachmentsRef.current[(newAttachments.length) - uploadAttachmentCount] as AttachmentMap;
            databaseInterfaceController.Queue('uploadAttachment', [
                ['uploadAttachment', 'true'],
                ['eventID', currentEditingMeetingEventIDRef.current],
                ['fileName', attachment.fileName],
                ['source', attachment.source, false], //third parameter is the encryption
                ['datetime_expired', attachment.datetime_expired != null ? IonDateString(attachment.datetime_expired).split(' ')[0] + ' 23:59:59' : 'null']
            ]);
        }
    }, [uploadAttachmentCount]);

    //watch for databaseResultActions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'createUpdateMeeting':
                        if (!JSON.stringify(res).includes('_false')) {
                            const meetingEventID = res;

                            // upload attachments to server
                            if (newAttachments.length > 0) {
                                UploadAttachments(meetingEventID);
                            }
                            else {
                                databaseInterfaceController.Queue('checkAndRemoveAttachments', [
                                    ['checkAndRemoveAttachments', 'true'],
                                    ['eventID', meetingEventID]
                                ]);
                                //close menu
                                SetShouldShowCreateEditMeetingMenu(false);
                                // display message
                                appContext.SetWaitScreenShouldShow(false);
                                appContext.SetPopupMessage(Object.keys(currentEditingMeeting).length == 0 ? 'New meeting created!' : 'Meeting updated!');
                                databaseInterfaceController.Queue('fetchMeetingInvitations', [
                                    ['fetchMeetingInvitations', 'true'],
                                    ['userID', appContext.user.userID]
                                ]);
                            }
                            // prompt server to send invitations
                            // console.log('checkNewInvitedIdsRef: ' + JSON.stringify(newInvitedIdsRef.current));
                            if (newInvitedIdsRef.current.length > 0) {
                                //send email & phone notification via email & sms
                                databaseInterfaceController.Queue('sendMeetingInvitationNotification', [
                                    ['sendMeetingInvitationNotification', 'true'],
                                    ['userIDs', newInvitedIdsRef.current.join(',')],
                                    ['meetingEventID', meetingEventID]
                                ]);
                                //send push notification to committee involved
                                databaseInterfaceController.Queue('sendMeetingInvitationPushNotification', [
                                    ['sendMeetingInvitationPushNotification', 'true'],
                                    ['userIDs', newInvitedIdsRef.current.join(',')],
                                    ['meetingEventID', meetingEventID]
                                ]);
                            }
                            //set an interval to check no attachmentCounts(all attachhments updated!)
                            // fetch hostedMeetings & hostedMeetingInvitations
                            if (checkAttachmentCountIntervalRef.current != null) {
                                clearInterval(checkAttachmentCountIntervalRef.current);
                            }
                            checkAttachmentCountIntervalRef.current = setInterval(() => {
                                if (uploadAttachmentCountRef.current == 0) {
                                    databaseInterfaceController.Queue('fetchHostedMeetings', [
                                        ['fetchHostedMeetings', 'true'],
                                        ['hostID', appContext.user.userID]
                                    ]);
                                    databaseInterfaceController.Queue('fetchHostedMeetingInvitations', [
                                        ['fetchHostedMeetingInvitations', 'true'],
                                        ['hostID', appContext.user.userID]
                                    ]);

                                    clearInterval(checkAttachmentCountIntervalRef.current);
                                    checkAttachmentCountIntervalRef.current = null;
                                }
                            }, nonstate.checkAttachmentCountInterval);
                        } else {
                            appContext.SetWaitScreenShouldShow(false);
                            appContext.SetPopupMessage('Fail to create meeting, please try again later.');
                            appContext.SetWaitScreenShouldShow(false);
                        }
                        break;
                    case 'uploadAttachment':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadAttachmentCountRef.current -= 1;
                            SetUploadAttachmentCount(uploadAttachmentCountRef.current);

                            if (uploadAttachmentCountRef.current == 0) {
                                //close menu
                                SetShouldShowCreateEditMeetingMenu(false);
                                // display message
                                appContext.SetWaitScreenShouldShow(false);
                                appContext.SetPopupMessage(Object.keys(currentEditingMeeting).length == 0 ? 'New meeting created!' : 'Meeting updated!');
                                databaseInterfaceController.Queue('fetchMeetingInvitations', [
                                    ['fetchMeetingInvitations', 'true'],
                                    ['userID', appContext.user.userID]
                                ]);
                            }
                        } else {
                            console.log('UploadAttachmentsErr: ' + res);
                        }
                        break;
                    case 'sendMeetingInvitationNotification':
                        if (!JSON.stringify(res).includes('_false')) {
                            console.log('sendMeetingInvitationNotificationSuccess!');
                        } else {
                            console.log('sendMeetingInvitationNotificationErr: ' + JSON.stringify(res));
                        }
                        break;
                    case 'sendMeetingInvitationPushNotification':
                        if (!JSON.stringify(res).includes('_false')) {
                            console.log('sendMeetingInvitationPushNotificationSuccess!');
                        } else {
                            console.log('sendMeetingInvitationPushNotificationErr: ' + JSON.stringify(res));
                        }
                        break;
                    case 'updateMeetingInvitationStatus':
                        if (!JSON.stringify(res).includes('_false')) {
                            databaseInterfaceController.Queue('fetchMeetingInvitations', [
                                ['fetchMeetingInvitations', 'true'],
                                ['userID', appContext.user.userID]
                            ]);
                            if (invitationStatusUpdateRef.current != null) {
                                switch (invitationStatusUpdateRef.current) {
                                    case MeetingInvitation_InvitationStatusMap.ACCEPTED:
                                        appContext.SetPopupMessage("You have ACCEPTED the meeting invitation.");
                                        break;
                                    case MeetingInvitation_InvitationStatusMap.DECLINED:
                                        appContext.SetPopupMessage("You have DECLINED the meeting invitation.");
                                        break;
                                    case MeetingInvitation_InvitationStatusMap.PENDING:
                                        appContext.SetPopupMessage("You have REVOKE the meeting invitation.");
                                        SetCurrentViewingMeeting({} as Event);
                                        break;
                                }
                            }
                        }
                        break;
                    case 'deleteMeeting':
                        if (!JSON.stringify(res).includes('_false')) {
                            databaseInterfaceController.Queue('fetchHostedMeetings', [
                                ['fetchHostedMeetings', 'true'],
                                ['hostID', appContext.user.userID]
                            ]);
                            databaseInterfaceController.Queue('fetchMeetingInvitations', [
                                ['fetchMeetingInvitations', 'true'],
                                ['userID', appContext.user.userID]
                            ]);
                            appContext.SetPopupMessage('Selected meeting deleted.');
                        } else {
                            appContext.SetPopupMessage('Fails to delete the selected meeting,\nPlease try again later.');
                            console.log('deleteEventErr: ' + res);
                        }
                        break;
                    case 'fetchMeetingsByEventIDs':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }

                            invitedMeetingsRef.current = [];
                            resObjs.map((resObj: any) => {
                                invitedMeetingsRef.current.push(new Event(
                                    resObj['eventID'],
                                    resObj['event_categoryID'],
                                    resObj['event_name'],
                                    resObj['event_name_highlight_texts'],
                                    resObj['event_name_highlight_colors'],
                                    resObj['event_desc'],
                                    resObj['event_poster'],
                                    resObj['event_file'],
                                    resObj['event_venue'],
                                    resObj['registration_start_date'],
                                    resObj['registration_end_date'],
                                    resObj['early_bird_start_date'],
                                    resObj['early_bird_end_date'],
                                    resObj['event_start_date'],
                                    resObj['event_end_date'],
                                    resObj['event_schedules'],
                                    resObj['max_pax'],
                                    resObj['hostID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['inapp_registration'],
                                    resObj['external_registration_link']
                                    // resObj['attachment_base_url'],
                                    // resObj['attachment_file_names']
                                ));
                            });
                            SetInvitedMeetings([...invitedMeetingsRef.current]);
                        } else {
                            console.log('fetchMeetingsByEventIDsErr: ' + res);
                        }
                        break;
                    // case 'fetchMeetingAttachmentsByEventIDs': --deprecated
                    case 'fetchViewableMeetingAttachmentsByEventIDs':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }

                            invitedMeetingAttachmentRef.current = [];
                            resObjs.map((resObj: any) => {
                                const invitedMeetingAttachment = new EventItem(
                                    resObj['itemID'],
                                    resObj['eventID'],
                                    resObj['base_url'],
                                    resObj['file_names'],
                                    resObj['datetime_expired'],
                                    resObj['type']
                                );
                                invitedMeetingAttachment.RemoveExpiredAttachments();
                                invitedMeetingAttachmentRef.current.push(invitedMeetingAttachment);
                            });
                            SetInvitedMeetings([...invitedMeetingsRef.current]);
                        } else {
                            console.log('fetchViewableMeetingAttachmentsByEventIDsErr' + res);
                        }
                        break;
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'createUpdateMeeting':
                case 'uploadAttachment':
                case 'checkAndRemoveAttachments':
                case 'sendMeetingInvitationNotification':
                case 'sendMeetingInvitationPushNotification':
                case 'updateMeetingInvitationStatus':
                case 'deleteMeeting':
                case 'fetchMeetingsByEventIDs':
                // case 'fetchMeetingAttachmentsByEventIDs': ---deprecated
                case 'fetchViewableMeetingAttachmentsByEventIDs':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnCreateUpdateMeetingClicked = () => {
        //checking form vars
        if (
            newTitle.replace(/\s/g, '').length > 0 &&
            newStartDateTime != null &&
            newEndDateTime != null &&
            newVenue.replace(/\s/g, '').length > 0 &&
            newMeetingCategoryID.replace(/\s/g, '').length > 0 &&
            IsAtleastOnePersonInvited()
        ) {
            committeeTypesListCheckings.map((committeeTypesListChecking: CommitteeTypesListCheckings) => {
                committeeTypesListChecking.list.map((committeeMember: MemberUser, i: number) => {
                    if (committeeTypesListChecking.checkings[i])
                        newInvitedIdsRef.current.push(committeeMember.userID);
                });
            });

            appContext.SetWaitScreenMessage('please wait');
            appContext.SetWaitScreenShouldShow(true);
            //send database create request
            databaseInterfaceController.Queue('createUpdateMeeting', [
                ['createUpdateMeeting', 'true'],
                ['initiatorID', appContext.user.userID],
                ['mode', Object.keys(currentEditingMeeting).length > 0 ? 'create' : 'update'],
                ['eventID', Object.keys(currentEditingMeeting).length > 0 ? currentEditingMeeting.eventID : ''],
                ['event_name', newTitle],
                ['event_categoryID', newMeetingCategoryID],
                ['event_desc', newAgenda],
                ['event_venue', newVenue],
                ['event_start_datetime', IonDateString(newStartDateTime != null ? newStartDateTime : new Date())],
                ['event_end_datetime', IonDateString(newEndDateTime != null ? newEndDateTime : new Date())],
                ['hostID', appContext.user.userID],
                ['invitation_userIDs', newInvitedIdsRef.current.join(',')]
            ]);
        } else {
            appContext.SetPopupMessage('All fields marked with (*) are compulsory');
        }
    }
    const OnViewDetailsClicked = (subject: MeetingInvitation | Event) => {
        if (subject instanceof (MeetingInvitation))
            SetCurrentSelectedInvitation(subject);
        else if (subject instanceof (Event))
            SetCurrentViewingMeeting(subject);
    }
    const OnAcceptDeclineInvitationClicked = (invitationStatus: number, meetingEventID: string) => {
        const messageParam = (invitationStatus == MeetingInvitation_InvitationStatusMap.ACCEPTED ? 'ACCEPT' : 'DECLINE');
        invitationStatusUpdateRef.current = invitationStatus;

        appContext.SetPopupMessage("Are you sure to " + messageParam + " the meeting invitation?");
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('updateMeetingInvitationStatus', [
                ['updateMeetingInvitationStatus', 'true'],
                ['userID', appContext.user.userID],
                ['eventID', meetingEventID],
                ['newStatus', invitationStatus],
                ['dateNow', IonDateString(new Date())]
            ]);
            SetCurrentSelectedInvitation({} as MeetingInvitation);
        }, () => SetCurrentSelectedInvitation({} as MeetingInvitation)]);
    }
    const OnViewAttachmentfileNameClicked = async (fileUrl: string) => {
        appContext.SetAppStateChangeWatch(false);
        Browser.addListener('browserFinished', () => { appContext.SetAppStateChangeWatch(true) });
        await Browser.open({ url: fileUrl });
    }
    const OnMenuCloseBtnClicked = () => {
        ResetFloatMenu();
        SetShouldShowInvitationsMenu(false);
    }
    const OnViewMeetingInfoClicked = (meeting: Event) => {
        SetCurrentViewingMeeting(meeting);
    }
    const OnRevokeInvitationClicked = (meetingEventID: string) => {
        const currentStatus = ViewMeetings_PageMap.UPCOMING ? 'ACCEPTED' : 'DECLINED';
        appContext.SetPopupMessage('Are you sure to REVOKE this ' + currentStatus + ' invitation?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('updateMeetingInvitationStatus', [
                ['updateMeetingInvitationStatus', 'true'],
                ['userID', appContext.user.userID],
                ['eventID', meetingEventID],
                ['newStatus', MeetingInvitation_InvitationStatusMap.PENDING],
                ['dateNow', IonDateString(new Date())]
            ]);
            invitationStatusUpdateRef.current = MeetingInvitation_InvitationStatusMap.PENDING;
        }, () => { }]);
    }
    const OnEditMeetingClicked = (meeting: Event) => {
        SetCurrentEditingMeeting(meeting);
        SetShouldShowCreateEditMeetingMenu(true);
    }
    const OnSelectAttachmentsClicked = async () => {
        appContext.SetAppStateChangeWatch(false);
        const files = await FilePicker.pickFiles({ readData: true, types: ['image/png', 'image/jpeg', 'application/pdf', 'text/csv', 'text/plain'], multiple: false })
            .then((res: any) => { return res.files })
            .catch((err: string) => { console.log('FilepickerPickFilesErr: ' + err); return []; });

        let someFilesOversized = false;
        files.map((file: any, i: number) => {
            if (file.size / (1048576) <= nonstate.max_attachment_size) {
                attemptUploadFileAttachmentRef.current = {
                    fileName: file.name,
                    source: 'data:' + file.mimeType + ';base64,' + file.data,
                    datetime_expired: null
                } as AttachmentMap;
                SetAttemptUploadAttachment(attemptUploadFileAttachmentRef.current);
            } else {
                someFilesOversized = true;
            }
        });

        if (someFilesOversized) {
            appContext.SetPopupMessage('Some files are not selected, please make sure the file size is below (' + nonstate.max_attachment_size + 'Kb)');
        }
    }
    const OnDeleteMeetingClicked = (meeting: Event) => {
        appContext.SetPopupMessage('Are you sure to delete the selected meeting ?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('deleteMeeting', [
                ['deleteMeeting', 'true'],
                ['initiatorID', appContext.user.userID],
                ['eventID', meeting.eventID]
            ]);
        }, () => { }]);
    }
    const OnRemoveAttachmentClicked = (attachment: AttachmentMap) => {
        //proceeds remove attachment
        const _newAttachments = newAttachmentsRef.current;
        newAttachmentsRef.current.map((_attachment: AttachmentMap, i: number) => {
            if (JSON.stringify(attachment) == JSON.stringify(_attachment)) {
                _newAttachments.splice(i, 1);
            }
        });
        newAttachmentsRef.current = _newAttachments;
        SetNewAttachments([...newAttachmentsRef.current]);
    }
    const OnAddToCalendarClicked = async (event: Event) => {
        const DSTAMP = FormatToICSDate(new Date()); //file created/initialized date
        const DSTART = FormatToICSDate(event.event_start_datetime != null ? event.event_start_datetime : new Date());
        const DEND = FormatToICSDate(event.event_end_datetime != null ? event.event_end_datetime : new Date());

        // 1. Define the content for the .ips file.
        const icsContentString = 'BEGIN:VCALENDAR\n' +
            'VERSION:2.0\n' +
            'PRODID:-//YourCompany//NONSGML v1.0//EN\n' +
            'BEGIN:VEVENT\n' +
            'UID:' + DSTAMP + 'ppkmsuperapp@neudimenxion.com\n' +
            'DTSTAMP:' + DSTAMP + '\n' +
            'DTSTART:' + DSTART + '\n' +
            'DTEND:' + DEND + '\n' +
            'SUMMARY:' + event.event_name + '\n' +
            'LOCATION:' + event.event_venue + '\n' +
            'DESCRIPTION:' + event.event_desc + '\n' +
            'STATUS:CONFIRMED\n' +
            'SEQUENCE:0\n' +
            'BEGIN:VALARM\n' +
            'TRIGGER:-PT10M\n' +
            'DESCRIPTION:Reminder for PPKM Meeting:' + event.event_name + '\n' +
            'ACTION:DISPLAY\n' +
            'END:VALARM\n' +
            'END:VEVENT\n' +
            'END:VCALENDAR';

        const icsContentBlob = new Blob([icsContentString], { type: 'text/Calendar' });
        const icsContentBase64 = await BlobToBase64(icsContentBlob).then((base64: any) => {
            return base64;
        }).catch((err: string) => {
            console.log('checkUploadFilesErr: ' + err);
        });

        if (isPlatform('hybrid')) {
            //save base64String to file
            try {
                const filePath = 'PPKM_Meeting_Calendar/' + event.eventID + '.ics';
                const result = await Filesystem.writeFile({
                    path: filePath,
                    data: icsContentBase64, // your data to write (ex. base64)
                    directory: Directory.Cache,
                    recursive: true
                });

                appContext.SetAppStateChangeWatch(false);
                await OpenICSFile(result.uri);
            } catch (err) {
                // alert('some error while write file: ' + err);
                // appContext.SetPopupMessage('Fail to download image, please try again later');
                appContext.SetPopupMessage('Calendar update failed. Please try again');
            }
        } else {
            appContext.SetPopupMessage('Calendar feature is only supported in Mobile App.');
        }
    }
    const OnAddAttachmentClicked = () => {
        if (
            attemptUploadFileLabel.length > 0
            && Object.keys(attemptUploadAttachment).length > 0
            && (
                !attemptUploadFileShouldExpire
                || attemptUploadFileDateTimeExpired != null
            )
        ) {
            const preFileNameArr = attemptUploadAttachment.fileName.split('.');
            const filePrefix = preFileNameArr[preFileNameArr.length - 1];

            const attachment = { fileName: attemptUploadFileLabel + '.' + filePrefix, source: attemptUploadAttachment.source, datetime_expired: attemptUploadFileDateTimeExpired } as AttachmentMap;
            newAttachmentsRef.current.push(attachment);
            SetNewAttachments([...newAttachmentsRef.current]);

            attemptUploadFileAttachmentRef.current = {} as AttachmentMap;
            SetAttemptUploadAttachment(attemptUploadFileAttachmentRef.current);
            SetAttemptUploadFileLabel('');
            SetAttemptUploadFileDateTimeExpired(null);
            SetShouldShowUploadAttachmentMenu(false);
        } else {
            appContext.SetPopupMessage('You must complete all fields marked with (*)');
        }
    }
    const OnRefreshBtnClicked = () => {
        appContext.SetWaitScreenMessage('please wait');
        appContext.SetWaitScreenShouldShow(true);
        setTimeout(() => {
            appContext.SetWaitScreenShouldShow(false);            
        }, 2000);

        databaseInterfaceController.Queue('fetchMeetingInvitations', [
            ['fetchMeetingInvitations', 'true'],
            ['userID', appContext.user.userID]
        ]);
        databaseInterfaceController.Queue('fetchHostedMeetings', [
            ['fetchHostedMeetings', 'true'],
            ['hostID', appContext.user.userID]
        ]);
        databaseInterfaceController.Queue('fetchHostedMeetingInvitations', [
            ['fetchHostedMeetingInvitations', 'true'],
            ['hostID', appContext.user.userID]
        ]);
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ViewMeetings_PageMap.UPCOMING:
                return RenderUpcomingPage();
            case ViewMeetings_PageMap.PAST:
                return RenderPastPage();
            case ViewMeetings_PageMap.DECLINED:
                return RenderDeclinedPage();
        }
    }
    const RenderUpcomingPage = () => {
        return (
            <Fragment>
                {
                    acceptedOngoingMeetings.length > 0 ?
                        acceptedOngoingMeetings.map((meeting: Event, i: number) => {
                            return (
                                <div className='view-row' key={'view-row-' + i}>
                                    <span className='view-row-lbl ex'>{meeting.event_name}</span>
                                    <span className='view-row-lbl'>{meeting.event_end_datetime! ? IonDateString(meeting.event_end_datetime) : ''}</span>
                                    <button className='view-row-btn' onClick={() => OnViewMeetingInfoClicked(meeting)}><InfoIcon /></button>
                                </div>
                            )
                        })
                        :
                        <span className='no-record-lbl'>No accepted current meetings found.</span>
                }
            </Fragment>
        );
    }
    const RenderPastPage = () => {
        return (
            <Fragment>
                {
                    acceptedPastMeetings.length > 0 ?
                        acceptedPastMeetings.map((meeting: Event, i: number) => {
                            return (
                                <div className='view-row' key={'view-row-' + i}>
                                    <span className='view-row-lbl ex'>{meeting.event_name}</span>
                                    <span className='view-row-lbl'>{meeting.event_end_datetime! ? IonDateString(meeting.event_end_datetime) : ''}</span>
                                    <button className='view-row-btn' onClick={() => OnViewMeetingInfoClicked(meeting)}><InfoIcon /></button>
                                </div>
                            )
                        })
                        :
                        <span className='no-record-lbl'>No accepted past meetings found.</span>
                }
            </Fragment>
        );
    }
    const RenderDeclinedPage = () => {
        return (
            <Fragment>
                {
                    declinedMeetigs.length > 0 ?
                        declinedMeetigs.map((meeting: Event, i: number) => {
                            return (
                                <div className='view-row' key={'view-row-' + i}>
                                    <span className='view-row-lbl ex'>{meeting.event_name}</span>
                                    <span className='view-row-lbl'>{meeting.event_end_datetime! ? IonDateString(meeting.event_end_datetime) : ''}</span>
                                    <button className='view-row-btn' onClick={() => OnViewMeetingInfoClicked(meeting)}><InfoIcon /></button>
                                </div>
                            )
                        })
                        :
                        <span className='no-record-lbl'>No declined meetings found.</span>
                }
            </Fragment>
        );
    }
    const RenderInvitationsMenu = () => {
        return (
            <Fragment>
                <div className='float-menu-blockscreen' />
                <div className='float-menu invitations'>
                    <button className='menu-close-btn' onClick={() => OnMenuCloseBtnClicked()}><CloseIcon /></button>
                    {
                        Object.keys(currentSelectedInvitation).length == 0 ?
                            RenderInvitationCards()
                            :
                            RenderInvitationDetails()
                    }
                </div>
            </Fragment>
        )
    }
    const RenderInvitationCards = () => {
        const pendingInvitations = FilterInvitationsByStatus(exAppContext.meetingInvitations, MeetingInvitation_InvitationStatusMap.PENDING);

        return (
            <Fragment>
                <span className='menu-title'>Meeting Invitations</span>
                <span className='menu-subtitle'>You have {pendingInvitations.length} pending invitations.</span>
                <div className='menu-content-scroll'>
                    {
                        pendingInvitations.map((invitation: MeetingInvitation, i: number) => {
                            const invitationMeeting = GetInvitedMeetingByID(invitation.eventID);
                            return (
                                <div className='menu-row' key={'menu-row-' + i}>
                                    <div className='menu-col'>
                                        <span className='menu-row-title'>{invitationMeeting.event_name}</span>
                                        <span className='menu-row-lbl'>Starts: <span className='menu-row-txt'>{invitationMeeting.event_start_datetime! ? IonDateString(invitationMeeting.event_start_datetime) : ''}</span></span>
                                        <span className='menu-row-lbl'>Ends: <span className='menu-row-txt'>{invitationMeeting.event_end_datetime! ? IonDateString(invitationMeeting.event_end_datetime) : ''}</span></span>
                                    </div>
                                    <div className='menu-col'>
                                        <button className='menu-row-btn' onClick={() => OnViewDetailsClicked(invitation)}>Details <ListIcon /></button>
                                        <button className='menu-row-btn accept' onClick={() => OnAcceptDeclineInvitationClicked(MeetingInvitation_InvitationStatusMap.ACCEPTED, invitation.eventID)}>Accept <DoneIcon /></button>
                                        <button className='menu-row-btn decline' onClick={() => OnAcceptDeclineInvitationClicked(MeetingInvitation_InvitationStatusMap.DECLINED, invitation.eventID)}>Decline <CloseIcon /></button>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </Fragment>
        );
    }
    const RenderInvitationDetails = () => {
        const selectedInvitationMeeting = GetInvitedMeetingByID(currentSelectedInvitation.eventID);
        const selectedInvitationMeetingAttachment = GetMeetingAttachmentItemByEventID(currentSelectedInvitation.eventID);
        //used by Invitation Info
        const meetingInvitations: MeetingInvitation[] = GetInvitationsOfMeeting(currentSelectedInvitation.eventID, MeetingInvitation_InvitationStatusMap.ALL);
        const acceptedInvitations: MeetingInvitation[] = GetInvitationsOfMeeting(currentSelectedInvitation.eventID, MeetingInvitation_InvitationStatusMap.ACCEPTED);

        return (
            <Fragment>
                <span className='menu-title'>Meeting Info</span>
                <div className='menu-content-scroll'>
                    <div className='menu-row ex'>
                        <span className='menu-row-lbl'>Title</span>
                        <span className='menu-row-txt'>{selectedInvitationMeeting.event_name}</span>
                    </div>
                    <div className='menu-row ex'>
                        <span className='menu-row-lbl'>Scheduled Time</span>
                        <span className='menu-row-txt'>Starts: {IonDateString(selectedInvitationMeeting.event_start_datetime, IonDateFormat.LONG_DATE_TIME) + '\nEnds: ' + IonDateString(selectedInvitationMeeting.event_end_datetime, IonDateFormat.LONG_DATE_TIME)}</span>
                    </div>
                    <div className='menu-row ex'>
                        <span className='menu-row-lbl'>Venue</span>
                        <span className='menu-row-txt'>{selectedInvitationMeeting.event_venue}</span>
                    </div>
                    <div className='menu-row ex'>
                        <span className='menu-row-lbl'>Agenda</span>
                        <span className='menu-row-txt'>{selectedInvitationMeeting.event_desc}</span>
                    </div>
                    <div className='menu-row ex'>
                        <span className='menu-row-lbl'>Attachments</span>
                        <div className='menu-scroll'>
                            {
                                selectedInvitationMeetingAttachment != null
                                    && selectedInvitationMeetingAttachment.file_names.length > 0 ?
                                    selectedInvitationMeetingAttachment.file_names.map((attachmentfileName: string) => {
                                        const attachmentUrl = selectedInvitationMeetingAttachment.base_url + attachmentfileName;
                                        return (
                                            <button className='attachment-btn' onClick={() => OnViewAttachmentfileNameClicked(attachmentUrl)}>{attachmentfileName}</button>
                                        )
                                    })
                                    :
                                    <span className='menu-scroll-lbl'>no attachment available</span>
                            }
                        </div>
                    </div>
                    <div className='menu-row ex'>
                        <span className='menu-row-lbl'>Invitation Details ({acceptedInvitations.length}/{meetingInvitations.length})</span>
                        <div className='menu-scroll ex'>
                            {
                                meetingInvitations.map((meetingInvitation: MeetingInvitation) => {
                                    const invitedCommitteeMember = GetCommitteeMemberByID(meetingInvitation.invitation_userID);
                                    return (
                                        <div className='menu-scroll-row'>
                                            <span className='menu-scroll-lbl'>{invitedCommitteeMember.name}</span>
                                            <span className='menu-scroll-lbl ex'>{GetCommitteeTypeLabelByID(invitedCommitteeMember.committee_typeID)}</span>
                                            {
                                                meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.ACCEPTED ?
                                                    <span className='menu-scroll-lbl ex green'>accepted</span>
                                                    :
                                                    (
                                                        meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.DECLINED ?
                                                            <span className='menu-scroll-lbl ex red'>declined</span>
                                                            :
                                                            (
                                                                meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.PENDING ?
                                                                    <span className='menu-scroll-lbl ex yellow'>pending</span>
                                                                    :
                                                                    null
                                                            )
                                                    )
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='option-panel'>
                    <button className='option-btn ex' onClick={() => SetCurrentSelectedInvitation({} as MeetingInvitation)}>Back</button>
                    <div className='option-group'>
                        <button className='option-btn' onClick={() => OnAcceptDeclineInvitationClicked(MeetingInvitation_InvitationStatusMap.ACCEPTED, currentSelectedInvitation.eventID)}>Accept <DoneIcon /></button>
                        <button className='option-btn' onClick={() => OnAcceptDeclineInvitationClicked(MeetingInvitation_InvitationStatusMap.DECLINED, currentSelectedInvitation.eventID)}>Decline <CloseIcon /></button>
                    </div>
                </div>
            </Fragment>
        )
        return null;
    }
    const RenderHostedMeetingsMenu = () => {
        return (
            <Fragment>
                <div className='float-menu-blockscreen' />
                <div className='float-menu hosted'>
                    <button className='menu-close-btn' onClick={() => SetShouldShowHostedMeetingsMenu(false)}><CloseIcon /></button>
                    {
                        Object.keys(currentSelectedInvitation).length == 0 ?
                            RenderHostedMeetingCards()
                            :
                            null
                    }
                </div>
            </Fragment>
        )
    }
    const RenderHostedMeetingCards = () => {
        return (
            <Fragment>
                <span className='menu-title'>Hosted Meetings</span>
                <span className='menu-subtitle'>You have hosted {exAppContext.hostedMeetings.length} meetings.</span>
                <div className='menu-content-scroll'>
                    {
                        exAppContext.hostedMeetings.map((meeting: Event, i: number) => {
                            return (
                                <div className='menu-row' key={'menu-row-' + i}>
                                    <div className='menu-col'>
                                        <span className='menu-row-title'>{meeting.event_name}</span>
                                        <span className='menu-row-lbl'>Starts: <span className='menu-row-txt'>{meeting.event_start_datetime! ? IonDateString(meeting.event_start_datetime) : ''}</span></span>
                                        <span className='menu-row-lbl'>Ends: <span className='menu-row-txt'>{meeting.event_end_datetime! ? IonDateString(meeting.event_end_datetime) : ''}</span></span>
                                    </div>
                                    <div className='menu-col'>
                                        {/* <button className='menu-row-btn accept' onClick={() => OnAcceptDeclineInvitationClicked(MeetingInvitation_InvitationStatusMap.ACCEPTED, invitation.eventID)}>Accept <DoneIcon /></button>
                                        <button className='menu-row-btn decline' onClick={() => OnAcceptDeclineInvitationClicked(MeetingInvitation_InvitationStatusMap.DECLINED, invitation.eventID)}>Decline <CloseIcon /></button> */}
                                        <button className='menu-row-btn' onClick={() => OnViewMeetingInfoClicked(meeting)}>Info <InfoIcon /></button>
                                        <button className='menu-row-btn' onClick={() => OnEditMeetingClicked(meeting)}>Edit <EditNoteIcon /></button>
                                        <button className='menu-row-btn' onClick={() => OnDeleteMeetingClicked(meeting)}>Delete <DeleteIcon /></button>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </Fragment>
        );
    }
    const RenderCreateEditMeetingMenu = () => {
        return (
            <Fragment>
                <div className='float-menu-blockscreen' />
                <div className='float-menu create-meeting'>
                    <span className='menu-title'>{Object.keys(currentEditingMeeting).length == 0 ? "Create New" : "Edit"} Meeting</span>
                    <div className='menu-content-scroll'>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Title*</span>
                            <input className='menu-row-in' value={newTitle} onChange={(e: any) => SetNewTitle(e.target.value)} placeholder='meeting title' />
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Category*</span>
                            <div className='menu-row-select'>
                                <SelectionBox selectionList={meetingCategoriesList} selectingKey={newMeetingCategoryID} SetSelectingKey={SetNewMeetingCategoryID} placeholder='Select a category' />
                            </div>
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Agenda</span>
                            <textarea className='menu-row-in' placeholder='meeting agenda ...' onChange={(e: any) => SetNewAgenda(e.target.value)} value={newAgenda}></textarea>
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Attachments</span>
                            {
                                newAttachments.length > 0 ?
                                    <div className='menu-row-scroll-block'>
                                        {
                                            newAttachments.map((attachment: AttachmentMap, i: number) => {
                                                return (
                                                    <div className='menu-row ex' key={'menu-row-' + i}>
                                                        <span className='menu-row-lbl short'>{(i + 1).toString()}.</span>
                                                        <span className='menu-row-lbl' key={'menu-row-lbl-' + i}>{attachment.fileName}</span>
                                                        {
                                                            attachment.datetime_expired != null ?
                                                                <div className='menu-row-expiration-lbl'>
                                                                    <span className='menu-row-lbl ex'>expiry:</span>
                                                                    <div className='menu-row-datetime-picker'>
                                                                        <DateTimePicker
                                                                            dateTime={attachment.datetime_expired}
                                                                            SetDateTime={(res: Date) => { UpdateNewAttachmentExpirationDate(res, i) }}
                                                                            buttonDisplayFormat={IonDateFormat.MALAYSIA_STANDARD_DATE}
                                                                            mode='date'
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        <button className='menu-row-rm-btn' onClick={() => OnRemoveAttachmentClicked(attachment)}><RemoveCircleIcon /></button>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    null
                            }
                            <button className='menu-row-btn' onClick={() => SetShouldShowUploadAttachmentMenu(true)}>Add Attachment</button>
                            {/*<button className='menu-row-btn' onClick={() => OnSelectAttachmentsClicked()}>Select attachments ({newAttachments.length} Selected)</button>*/}
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Starts*</span>
                            <div className='menu-row-datetime-picker'><DateTimePicker dateTime={newStartDateTime} SetDateTime={SetNewStartDateTime} mode='datetime' /></div>
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Ends*</span>
                            <div className='menu-row-datetime-picker'><DateTimePicker dateTime={newEndDateTime} SetDateTime={SetNewEndDateTime} mode='datetime' /></div>
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Venue*</span>
                            <textarea className='menu-row-in' placeholder='meeting venue ...' onChange={(e: any) => SetNewVenue(e.target.value)} value={newVenue}></textarea>
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Also invite*</span>
                            <div className='menu-row-select-checker'>
                                {/* <SelectionChecker checkList={committeeTypesListCheckings.} checkings={committeeCheckings} SetCheckings={SetCommitteeCheckings} placeholder='Invite committee members' direction='up' />
                                <SelectionChecker checkList={secretariateList.map((committeeUser: MemberUser) => committeeUser.name)} checkings={secretariateCheckings} SetCheckings={SetSecretariateCheckings} placeholder='Invite secretariate members' direction='up' />
                                <SelectionChecker checkList={advisorList.map((committeeUser: MemberUser) => committeeUser.name)} checkings={advisorCheckings} SetCheckings={SetAdvisorCheckings} placeholder='Invite advisor members' direction='up' /> */}
                                {
                                    committeeTypesListCheckings.map((committeeTypeListChecking: CommitteeTypesListCheckings, i: number) => {
                                        return (
                                            <SelectionChecker checkList={committeeTypeListChecking.list.map((committeeUser: MemberUser) => committeeUser.name)} checkings={committeeTypeListChecking.checkings} SetCheckings={(newCheckings: boolean[]) => UpdateCommitteeTypeListCheckings(i, newCheckings)} placeholder={'Invite ' + InitialCaps(committeeTypeListChecking.committeeType.label) + ' Members'} direction='up' />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <button className='menu-close-btn' onClick={() => { SetShouldShowCreateEditMeetingMenu(false); SetCurrentEditingMeeting({} as Event); }}><CloseIcon /></button>
                    <button className='menu-submit-btn' onClick={() => { OnCreateUpdateMeetingClicked() }}>{Object.keys(currentEditingMeeting).length > 0 ? 'UPDATE' : 'CREATE'}</button>
                </div>
            </Fragment>
        )
    }
    const RenderMeetingInfoMenu = () => {
        //used by ACCEPTED/DECLINED/GENERAL PAGE MODE
        const meetingInvitation: MeetingInvitation = GetInvitationOfMeeting(currentViewingMeeting.eventID);
        const meetingAttachments = GetMeetingAttachmentItemByEventID(currentViewingMeeting.eventID);
        const invitationMeeting = GetInvitedMeetingByID(meetingInvitation.eventID);
        const invitationDateTimeUpdated = (meetingInvitation.datetime_updated != null ? IonDateString(meetingInvitation.datetime_updated) : '');
        const meetingDateTimeUpdated = (
            invitationMeeting.datetime_updated != null ?
                IonDateString(invitationMeeting.datetime_updated)
                :
                (
                    invitationMeeting.datetime_created != null ?
                        IonDateString(invitationMeeting.datetime_created)
                        :
                        ''
                )
        );
        //used by Invitation Info
        const meetingInvitations: MeetingInvitation[] = GetInvitationsOfMeeting(currentViewingMeeting.eventID, MeetingInvitation_InvitationStatusMap.ALL);
        const acceptedInvitations: MeetingInvitation[] = GetInvitationsOfMeeting(currentViewingMeeting.eventID, MeetingInvitation_InvitationStatusMap.ACCEPTED);

        return (
            <Fragment>
                <div className='float-menu-blockscreen' />
                <div className='float-menu meeting-info'>
                    <button className='menu-close-btn' onClick={() => SetCurrentViewingMeeting({} as Event)}><CloseIcon /></button>
                    <span className='menu-title'>Meeting Info</span>
                    {/* <span className='menu-subtitle'><b>{currentViewingMeeting.event_name}</b><br />
                        <span className='menu-subtitle ex'>
                            {
                                page == ViewMeetings_PageMap.DECLINED ?
                                    'declined on ' + invitationDateTimeUpdated
                                    :
                                    (
                                        shouldShowHostedMeetingsMenu ?
                                            'updated on ' + meetingDateTimeUpdated
                                            :
                                            'accepted on ' + invitationDateTimeUpdated
                                    )
                            }
                        </span>
                    </span> ---deprecated*/}
                    <div className='menu-content-scroll'>
                        <div className='menu-row ex'>
                            <span className='menu-row-lbl'>Title</span>
                            <span className='menu-row-txt'>{currentViewingMeeting.event_name}</span>
                        </div>
                        <div className='menu-row ex'>
                            <span className='menu-row-lbl'>Scheduled Time</span>
                            <span className='menu-row-txt'>
                                {'Starts : ' + IonDateString(currentViewingMeeting.event_start_datetime, IonDateFormat.LONG_DATE_TIME)}<br />
                                {'Ends : ' + IonDateString(currentViewingMeeting.event_end_datetime, IonDateFormat.LONG_DATE_TIME)}
                            </span>
                        </div>
                        <div className='menu-row ex'>
                            <span className='menu-row-lbl'>Venue</span>
                            <span className='menu-row-txt'>{currentViewingMeeting.event_venue}</span>
                        </div>
                        <div className='menu-row ex'>
                            <span className='menu-row-lbl'>Agenda</span>
                            <span className='menu-row-txt'>{currentViewingMeeting.event_desc}</span>
                        </div>
                        <div className='menu-row ex'>
                            <span className='menu-row-lbl'>Attachments</span>
                            <div className='menu-scroll'>
                                {
                                    meetingAttachments != null ?
                                        meetingAttachments.file_names.map((attachmentfileName: string, i: number) => {
                                            const attachmentUrl = meetingAttachments.base_url + attachmentfileName;

                                            return (
                                                <button key={'attachment-btn-' + i} className='attachment-btn' onClick={() => OnViewAttachmentfileNameClicked(attachmentUrl)}>{attachmentfileName}</button>
                                            )
                                        })
                                        :
                                        <span className='menu-scroll-lbl'>no attachments available</span>
                                }
                            </div>
                        </div>
                        <div className='menu-row ex'>
                            <span className='menu-row-lbl'>Invitation Details ({acceptedInvitations.length}/{meetingInvitations.length})</span>
                            <div className='menu-scroll ex'>
                                {
                                    meetingInvitations.map((meetingInvitation: MeetingInvitation) => {
                                        const invitedCommitteeMember = GetCommitteeMemberByID(meetingInvitation.invitation_userID);
                                        return (
                                            <div className='menu-scroll-row'>
                                                <span className='menu-scroll-lbl'>{invitedCommitteeMember.name}</span>
                                                <span className='menu-scroll-lbl ex'>{GetCommitteeTypeLabelByID(invitedCommitteeMember.committee_typeID)}</span>
                                                {
                                                    meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.ACCEPTED ?
                                                        <span className='menu-scroll-lbl ex green'>accepted</span>
                                                        :
                                                        (
                                                            meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.DECLINED ?
                                                                <span className='menu-scroll-lbl ex red'>declined</span>
                                                                :
                                                                (
                                                                    meetingInvitation.invitation_status == MeetingInvitation_InvitationStatusMap.PENDING ?
                                                                        <span className='menu-scroll-lbl ex yellow'>pending</span>
                                                                        :
                                                                        null
                                                                )
                                                        )
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className='option-panel ex'>
                        {
                            page == ViewMeetings_PageMap.DECLINED ?
                                <button className='option-btn' onClick={() => OnRevokeInvitationClicked(currentViewingMeeting.eventID)}>Revoke</button>
                                :
                                (
                                    <Fragment>
                                        <button className='option-btn wide' onClick={() => OnRevokeInvitationClicked(currentViewingMeeting.eventID)}>Revoke</button>
                                        <button className='option-btn wide' onClick={() => OnAddToCalendarClicked(currentViewingMeeting)}>Add To Calendar</button>
                                    </Fragment>
                                )
                        }
                    </div>
                </div>
            </Fragment>
        )
    }
    const RenderUploadAttachmentMenu = () => {
        return (
            <Fragment>
                <div className='float-menu-blockscreen' />
                <div className='float-menu upload-attachment'>
                    <span className='menu-title'>Upload Attachments</span>
                    <div className='menu-content-scroll' ref={menuContentScrollRef}>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Attachment File* (max: {nonstate.max_attachment_size}Mb/file)</span>
                            <span className='menu-row-lbl ex'>{attemptUploadAttachment.fileName}</span>
                            <button className='menu-row-btn' onClick={() => OnSelectAttachmentsClicked()}>Browse Attachment</button>
                        </div>
                        <div className='menu-row'>
                            <span className='menu-row-lbl'>Attachment Label*</span>
                            <input className='menu-row-in' value={attemptUploadFileLabel} onChange={(e: any) => { SetAttemptUploadFileLabel(e.target.value); }} />
                        </div>
                        <div className='menu-row'>
                            <div className='menu-row-checker'>
                                <Checker checked={attemptUploadFileShouldExpire} SetChecked={SetAttemptUploadFileShouldExpire}
                                    OnCheckerClicked={() => {
                                        setTimeout(() => {
                                            menuContentScrollRef.current.scrollTo({ top: menuContentScrollRef.current.scrollHeight, behavior: 'smooth' });
                                        }, 100);
                                    }}
                                    label='Document should expire'
                                />
                            </div>
                        </div>
                        {
                            attemptUploadFileShouldExpire ?
                                <div className='menu-row'>
                                    <div className='menu-row-datetime-picker'>
                                        <span className='menu-row-lbl'>Attachment Expiration Date *</span>
                                        <DateTimePicker dateTime={attemptUploadFileDateTimeExpired} SetDateTime={SetAttemptUploadFileDateTimeExpired} mode='date' />
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                    <button className='menu-close-btn' onClick={() => {
                        //reset form
                        SetAttemptUploadFileLabel('');
                        SetAttemptUploadAttachment({} as AttachmentMap);
                        SetAttemptUploadFileShouldExpire(false);
                        SetAttemptUploadFileDateTimeExpired(null);
                        attemptUploadFileAttachmentRef.current = {} as AttachmentMap;
                        SetShouldShowUploadAttachmentMenu(false);
                    }}><CloseIcon /></button>
                    <button className='menu-submit-btn' onClick={() => OnAddAttachmentClicked()}>Add Attachment</button>
                </div>
            </Fragment>
        )
    }

    //exe functions
    const ResetFloatMenu = () => {
        ResetForm();
        SetCurrentSelectedInvitation({} as MeetingInvitation);
        invitationStatusUpdateRef.current = null;
    }
    const ResetForm = () => {
        if (Object.keys(currentEditingMeeting).length == 0) {
            SetNewTitle('');
            SetNewMeetingCategoryID('');
            SetNewAgenda('');
            newAttachmentsRef.current = [] as AttachmentMap[];
            SetNewAttachments([...newAttachmentsRef.current]);
            SetNewStartDateTime(null);
            SetNewEndDateTime(null);
            SetNewVenue('');
            ResetCommitteeTypesListCheckings();
            newInvitedIdsRef.current = [];
        } else {
            SetNewTitle(currentEditingMeeting.event_name);
            SetNewMeetingCategoryID(currentEditingMeeting.event_categoryID);
            SetNewAgenda(currentEditingMeeting.event_desc);
            const meetingAttachment = GetHostedMeetingAttachmentItemByEventID(currentEditingMeeting.eventID);

            newAttachmentsRef.current = [] as AttachmentMap[];
            if (meetingAttachment != null) {
                meetingAttachment.file_names.map((fileName: string, i: number) => {
                    newAttachmentsRef.current.push({ fileName: fileName, source: meetingAttachment.base_url + fileName, datetime_expired: meetingAttachment.datetime_expired[i] } as AttachmentMap);
                });
            }
            SetNewAttachments([...newAttachmentsRef.current]);

            SetNewStartDateTime(currentEditingMeeting.event_start_datetime != null ? currentEditingMeeting.event_start_datetime : new Date());
            SetNewEndDateTime(currentEditingMeeting.event_end_datetime != null ? currentEditingMeeting.event_end_datetime : new Date());
            SetNewVenue(currentEditingMeeting.event_venue);

            committeeTypesListCheckings.map((committeeTypesListChecking: CommitteeTypesListCheckings, i: number) => {
                UpdateCommitteeTypeListCheckings(i, GetInvitationCheckings(
                    committeeTypesListChecking.list,
                    GetInvitationsOfMeeting(currentEditingMeeting.eventID, MeetingInvitation_InvitationStatusMap.ALL)
                ))
            });

            newInvitedIdsRef.current = [];
        }
    }
    const FilterInvitationsByStatus = (invitations: MeetingInvitation[], filterStatus: number) => {
        const filtered = [] as MeetingInvitation[];

        invitations.map((invitation: MeetingInvitation) => {
            if (invitation.invitation_status == filterStatus)
                filtered.push(invitation);
        });

        return filtered;
    }
    const SortMeetings = (meetings: Event[], sort: SortMap) => {
        let sorted = [] as Event[]; let unsorted: Event[] = meetings;

        //sort by title alphabets order
        unsorted.map((meeting: Event) => {
            let isSorted = false;
            sorted.map((_meeting: Event, i: number) => {
                if (!isSorted) {
                    if (
                        (sort.titleSort && AlphabetNumericSortCompare(meeting.event_name, _meeting.event_name)) ||
                        (!sort.titleSort && !AlphabetNumericSortCompare(meeting.event_name, _meeting.event_name))
                    ) {
                        sorted.splice(i, 0, meeting);
                        isSorted = true;
                    }
                }
            });

            if (!isSorted) {
                sorted.push(meeting);
            }
        });

        //sort by meeting date of conduct
        unsorted = sorted;
        sorted = [] as Event[];
        unsorted.map((meeting: Event) => {
            let isSorted = false;
            sorted.map((_meeting: Event, i: number) => {
                if (!isSorted) {
                    if (
                        meeting.event_start_datetime! && _meeting.event_start_datetime! &&
                        (
                            (sort.dateSort && meeting.event_start_datetime <= _meeting.event_start_datetime) ||
                            (!sort.dateSort && meeting.event_start_datetime >= _meeting.event_start_datetime)
                        )
                    ) {
                        sorted.splice(i, 0, meeting);
                        isSorted = true;
                    }
                }
            });
            if (!isSorted) {
                sorted.push(meeting);
            }
        });

        return sorted;
    }
    const FilterMeetings = (meetings: Event[]) => {
        const filtered = [] as Event[];
        meetings.map((meeting: Event) => {
            if (meeting.event_name.toLowerCase().includes(filter_searchString.toLowerCase())) {
                filtered.push(meeting);
            }
        });
        return filtered;
    }
    const AlphabetNumericSortCompare = (stringA: string, stringB: string) => {
        //if A goes first return true, if B goes first return false
        //the arrangement is in ascending order, add "!" to make it descending order
        const stringAArr: string[] = stringA.split('');
        const stringBArr: string[] = stringB.split('');
        let res = true; let sorted = false;

        stringAArr.map((aChar: string) => {
            stringBArr.map((bChar: string) => {
                if (
                    !sorted &&
                    nonstate.alphabetNumericOrderMap[aChar as keyof typeof nonstate.alphabetNumericOrderMap] >
                    nonstate.alphabetNumericOrderMap[bChar as keyof typeof nonstate.alphabetNumericOrderMap]
                ) {
                    res = true; sorted = true;
                } else if (
                    !sorted &&
                    nonstate.alphabetNumericOrderMap[aChar as keyof typeof nonstate.alphabetNumericOrderMap] <
                    nonstate.alphabetNumericOrderMap[bChar as keyof typeof nonstate.alphabetNumericOrderMap]
                ) {
                    res = false; sorted = true;
                }
            });
        });
        return res;
    }
    const GetInvitationOfMeeting = (meetingEventID: string) => {
        let res = {} as MeetingInvitation;
        exAppContext.meetingInvitations.map((meetingInvitation: MeetingInvitation) => {
            if (meetingInvitation.eventID == meetingEventID)
                res = meetingInvitation;
        });
        return res;
    }
    const BlobToBase64 = (blob: Blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                // The result is the Base64 string
                resolve(reader.result);
            };

            reader.onerror = () => {
                console.log('Failed to convert Blob to Base64');
                reject('');
            };

            // Read the Blob as a Data URL
            reader.readAsDataURL(blob);
        });
    }
    const UploadAttachments = (meetingEventID: string) => {
        uploadAttachmentCountRef.current = newAttachments.length;
        SetUploadAttachmentCount(uploadAttachmentCountRef.current);
        currentEditingMeetingEventIDRef.current = meetingEventID;
    }
    const GetInvitationsOfMeeting = (eventID: string, statusMode: number) => {
        const meetingInvitations = [] as MeetingInvitation[];
        exAppContext.hostedMeetingInvitations.map((meetingInvitation: MeetingInvitation) => {
            if (
                meetingInvitation.eventID == eventID &&
                (
                    statusMode == MeetingInvitation_InvitationStatusMap.ALL ||
                    meetingInvitation.invitation_status == statusMode
                )
            )
                meetingInvitations.push(meetingInvitation);
        });
        return meetingInvitations;
    }
    const GetCommitteeMemberByID = (userID: string) => {
        let committeeMember = {} as MemberUser;
        exAppContext.allCommitteeMembers.map((memberUser: MemberUser) => {
            if (memberUser.userID == userID)
                committeeMember = memberUser;
        });
        return committeeMember;
    }
    const GetCommitteeTypeLabelByID = (typeID: string) => {
        // switch (typeNo) {
        //     default:
        //     case MemberUser_CommitteeTypeMap.COMMITTEE:
        //         return 'committee';
        //     case MemberUser_CommitteeTypeMap.SECRETARIATE:
        //         return 'secretariate';
        //     case MemberUser_CommitteeTypeMap.ADVISOR:
        //         return 'advisor';
        // } ---deprecated
        let label = '';
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.committee_typeID == typeID)
                label = committeeType.label;
        });
        return label;
    }
    const GetInvitationCheckings = (list: MemberUser[], meetingInvitations: MeetingInvitation[]) => {
        const checkings = [] as boolean[];
        list.map((memberUser: MemberUser) => {
            let invitationFound = false;
            meetingInvitations.map((meetingInvitation: MeetingInvitation) => {
                if (meetingInvitation.invitation_userID == memberUser.userID)
                    invitationFound = true;
            });
            if (invitationFound)
                checkings.push(true);
            else
                checkings.push(false);
        });
        return checkings;
    }
    const MatchCommitteeTypeIDWithLabel = (committeeTypeID: string, label: string) => {
        let isMatched = false;
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.committee_typeID == committeeTypeID && committeeType.label.toLowerCase() == label.toLowerCase()) {
                isMatched = true;
            }
        });
        return isMatched;
    }
    // const GetEventByID = (eventID: string):Event => {
    //     let event = {} as Event;
    //     exAppContext.allEvents.map((_event: Event) => {
    //         if(_event.eventID == eventID)
    //             event = _event;
    //     });
    //     return event;
    // } ---deprecated
    const GetInvitedMeetingByID = (eventID: string): Event => {
        let res = {} as Event;
        invitedMeetingsRef.current.map((invitedMeeting: Event) => {
            if (invitedMeeting.eventID == eventID)
                res = invitedMeeting;
        });
        return res;
    }
    const GetMeetingAttachmentItemByEventID = (eventID: string): EventItem | null => {
        let res = null;
        invitedMeetingAttachmentRef.current.map((invitedMeetingAttachment: EventItem) => {
            if (invitedMeetingAttachment.eventID == eventID)
                res = invitedMeetingAttachment;
        });
        return res;
    }
    const GetHostedMeetingAttachmentItemByEventID = (eventID: string): EventItem | null => {
        let res = null;
        exAppContext.hostedMeetingAttachments.map((attachment: EventItem) => {
            if (attachment.eventID == eventID)
                res = attachment;
        });
        return res;
    }
    const OpenICSFile = async (filePath: string) => {
        try {
            const fileOpenerOptions: FileOpenerOptions = {
                filePath: filePath,
                contentType: 'text/calendar',
                openWithDefault: true,
            };
            await FileOpener.open(fileOpenerOptions);
            appContext.SetPopupMessage('Calendar added successfully.');
        } catch (e) {
            console.log('Error opening file', e);
            appContext.SetPopupMessage('Calendar not added, please check that you have calendar app installed on your device.');
        }
    }
    const FormatToICSDate = (date: Date) => {
        const pad = (num: any) => num.toString().padStart(2, '0');  // Helper function to add leading zeroes

        // Get date parts
        const year = date.getUTCFullYear();
        const month = pad(date.getUTCMonth() + 1); // Months are 0-based in JavaScript
        const day = pad(date.getUTCDate());
        const hours = pad(date.getUTCHours());
        const minutes = pad(date.getUTCMinutes());
        const seconds = pad(date.getUTCSeconds());

        // Return the formatted date string in the ICS format
        return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
    }
    const UpdateCommitteeTypeListCheckings = (index: number, newCheckings: boolean[]) => {
        const _committeeTypesListCheckings = committeeTypesListCheckings;
        _committeeTypesListCheckings[index].checkings = newCheckings;
        SetCommitteeTypesListCheckings([..._committeeTypesListCheckings]);
    }
    const ResetCommitteeTypesListCheckings = () => {
        const _committeeTypesListCheckings = committeeTypesListCheckings;
        _committeeTypesListCheckings.map((committeeTypesListChecking: CommitteeTypesListCheckings) => {
            const checkings = [] as boolean[];
            committeeTypesListChecking.list.map((committeeMember: MemberUser) => {
                checkings.push(false);
            });
            committeeTypesListChecking.checkings = checkings;
        });
        SetCommitteeTypesListCheckings([..._committeeTypesListCheckings]);
    }
    const InitialCaps = (sub: string) => {
        const subArr = sub.split(' ');
        const resArr = [] as string[];
        subArr.map((sub: string) => {
            resArr.push(sub.substring(0, 1).toUpperCase() + sub.substring(1, sub.length));
        });
        return resArr.join(' ');
    }
    const UpdateNewAttachmentExpirationDate = (newDate: Date, index: number) => {
        const attachment = newAttachmentsRef.current[index];

        newAttachmentsRef.current[index] = {
            fileName: attachment.fileName,
            source: attachment.source,
            datetime_expired: newDate
        } as AttachmentMap;

        SetNewAttachments([...newAttachmentsRef.current]);
    }

    //checkings
    const IsAtleastOnePersonInvited = () => {
        let res = false;
        // committeeCheckings.map((checkings: boolean) => {
        //     if(checkings == true)
        //         res = true;
        // }); --deprecated
        committeeTypesListCheckings.map((committeeTypesListCheking: CommitteeTypesListCheckings) => {
            committeeTypesListCheking.checkings.map((check: boolean) => {
                if (check)
                    res = true;
            });
        });
        return res;
    }
    const IsSecretariat = () => {
        let res = false;
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (
                committeeType.label.toLowerCase() == 'secretariat'
                && appContext.user.committee_typeID == committeeType.committee_typeID
            )
                res = true;
        });
        return res;
    }

    return (
        <div className='ViewMeetings'>
            <div className='view-menu'>
                <div className='option-panel'>
                    <div className='nav-panel'>
                        <button className={'nav-btn left ' + (page == ViewMeetings_PageMap.UPCOMING ? 'expand' : '')} onClick={() => SetPage(ViewMeetings_PageMap.UPCOMING)}>
                            {page == ViewMeetings_PageMap.UPCOMING ? 'Current Meetings' : ''} <CalendarMonthIcon />
                        </button>
                        <button className={'nav-btn ' + (page == ViewMeetings_PageMap.PAST ? 'expand' : '')} onClick={() => SetPage(ViewMeetings_PageMap.PAST)}>
                            {page == ViewMeetings_PageMap.PAST ? 'Past Meetings' : ''} <ManageSearchIcon />
                        </button>
                        <button className={'nav-btn ' + (page == ViewMeetings_PageMap.DECLINED ? 'expand' : '')} onClick={() => SetPage(ViewMeetings_PageMap.DECLINED)}>
                            {page == ViewMeetings_PageMap.DECLINED ? 'Declined Meetings' : ''} <RecyclingIcon />
                        </button>
                    </div>
                    <div className='search-sort-panel'>
                        <div className='search-sort-block extend'>
                            <span className='block-lbl'>Title</span>
                            <div className='search-in-block'>
                                <input className='search-in' value={filter_searchString} onChange={(e: any) => SetFilter_SearchString(e.target.value)} />
                                <SearchIcon />
                            </div>
                            <button className='sort-btn' onClick={() => SetSort({ titleSort: !sort.titleSort, dateSort: sort.dateSort } as SortMap)}>{sort.titleSort ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</button>
                        </div>
                        <div className='search-sort-block'>
                            <span className='block-lbl'>Date</span>
                            <button className='sort-btn' onClick={() => SetSort({ titleSort: sort.titleSort, dateSort: !sort.dateSort } as SortMap)}>{sort.dateSort ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</button>
                        </div>
                    </div>
                </div>
                <div className='view-scroll'>
                    {RenderPage()}
                </div>
            </div>
            <div className='option-menu'>
                {
                    IsSecretariat() ?
                        < Fragment >
                            < button className='option-menu-btn left' onClick={() => SetShouldShowInvitationsMenu(true)}>
                                Invitations
                                {
                                    FilterInvitationsByStatus(exAppContext.meetingInvitations, MeetingInvitation_InvitationStatusMap.PENDING).length > 0 ?
                                        <span className='option-menu-notify-lbl'>
                                            {
                                                FilterInvitationsByStatus(
                                                    exAppContext.meetingInvitations,
                                                    MeetingInvitation_InvitationStatusMap.PENDING
                                                ).length
                                            }
                                        </span>
                                        :
                                        null
                                }
                            </button>
                            <button className='option-menu-btn center' onClick={() => SetShouldShowHostedMeetingsMenu(true)}>Hosted Meetings</button>
                            <button className='option-menu-btn right' onClick={() => SetShouldShowCreateEditMeetingMenu(true)}>New Meeting<AddIcon /></button>
                        </Fragment>
                        :
                        < button className='option-menu-btn full' onClick={() => SetShouldShowInvitationsMenu(true)}>
                            Invitations
                            {
                                FilterInvitationsByStatus(exAppContext.meetingInvitations, MeetingInvitation_InvitationStatusMap.PENDING).length > 0 ?
                                    <span className='option-menu-notify-lbl'>
                                        {
                                            FilterInvitationsByStatus(
                                                exAppContext.meetingInvitations,
                                                MeetingInvitation_InvitationStatusMap.PENDING
                                            ).length
                                        }
                                    </span>
                                    :
                                    null
                            }
                        </button>
                }
            </div>
            <button className='refresh-btn' onClick={() => OnRefreshBtnClicked()}><ReplayIcon /></button>
            {/** Invitation Menu */}
            {
                shouldShowInvitationsMenu ?
                    RenderInvitationsMenu()
                    :
                    null
            }
            {/** Hosted Meeting Menu */}
            {
                shouldShowHostedMeetingsMenu ?
                    RenderHostedMeetingsMenu()
                    :
                    null
            }
            {/** Create | Edit Meeting Menu */}
            {
                shouldShowCreateEditMeetingMenu ?
                    RenderCreateEditMeetingMenu()
                    :
                    null
            }
            {
                shouldShowUploadAttachmentMenu ?
                    RenderUploadAttachmentMenu()
                    :
                    null
            }
            {/** View Meeting Info */}
            {
                Object.keys(currentViewingMeeting).length ?
                    RenderMeetingInfoMenu()
                    :
                    null
            }
        </div >
    )
}
export default ViewMeetings;